import React from 'react';
import PropTypes from 'prop-types';

class Fields extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: props.fields
    };

  }

  render() {

    const { fields } = this.state;
    const { onChangeInput } = this.props;

    return (
      <div className={"fields"}>
        {fields.map((field, index) => {
            return <input key={index}
                          className={field.hasError ? "has-error" : ""}
                          type={field.name === "phone" ? "phone" : "text"}
                          name={field.name}
                          placeholder={field.placeholder}
                          value={field.value}
                          onChange={onChangeInput} />
        }
        )}
      </div>
    );

  }
}

Fields.propTypes = {
  onChangeInput: PropTypes.func,
};

export default Fields;
